import { Selector } from '@mews/framework';
import { Identifiable } from '@mews/std';
import { MessageThread } from '@mews-commander/messages';
import { ApplicationState } from '@mews-commander/types';
import { getThreadOriginalSender as getThreadOriginalSenderJS } from '@mews-commander/legacy-entities/src/ducks/threads';

export const getThreadOriginalSender = getThreadOriginalSenderJS as Selector<
    ApplicationState,
    Identifiable,
    MessageThread['originalSender'] | undefined
>;
